<template>
  <div class="pt-16 pb-32 container-base">
    <BaseLoader
      v-if="loading.tabs"
      class="min-h-[300px] grid place-items-center"
    />

    <q-card v-else-if="tabs.length">
      <header class="p-24 flex items-center">
        <TextIcon
          icon="svguse:#icon_files"
          :text="t('requests.title')"
          icon-class="text-primary-pure"
        />
        <!--  <q-space />
        <OButton size="md" label="Anexar arquivo" primary /> -->
      </header>

      <OTabs v-model="tab" :tabs="tabs" class="w-max" />

      <q-tab-panels v-model="tab" animated keep-alive>
        <template v-for="categoria in tabs" :key="categoria.name">
          <q-tab-panel :name="categoria.name">
            <section class="px-24 pt-16 pb-5">
              <OTableSolicitacoes
                :cols-solicitacoes-arquivos
                :categoria
                @click="
                  (grupo, props) =>
                    openModalSolicitacao(
                      props.row,
                      'comentarios',
                      grupo
                    )
                "
                @click:anexar="
                  (grupo, props) =>
                    openModalSolicitacao(props.row, 'uploads', grupo)
                "
              />
            </section>
          </q-tab-panel>
        </template>
      </q-tab-panels>
    </q-card>

    <div
      v-else
      class="w-full h-[calc(100vh-3rem)] grid place-items-center"
    >
      <EmptyItem :text="t('error.permissionDenied')" />
    </div>
  </div>

  <ModalSolicitacao ref="refModalSolicitacao" />
</template>

<script setup>
import { categoriaArquivosService } from 'services/categoriasArquivos.service'
import { computed, onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import BaseLoader from 'components/Loader/BaseLoader.vue'
import EmptyItem from 'components/Empty/EmptyItem.vue'
import ModalSolicitacao from 'components/Modal/ModalSolicitacao.vue'
import OTableServerSideBase from 'components/Table/OTableServerSideBase.vue'
import OTableSolicitacoes from 'components/Table/OTableSolicitacoes.vue'
import OTabs from 'components/Tabs/OTabs.vue'
import TextIcon from 'components/Text/TextIcon.vue'
import TrSolicitacoesArquivos from 'components/Tr/TrSolicitacoesArquivos.vue'
import useApiError from 'composables/useApiError'

const { t } = useI18n()

const tab = ref()

const refModalSolicitacao = ref(null)
const tabs = ref([])

function openModalSolicitacao(row, tab, grupo) {
  refModalSolicitacao.value.open({ row, tab, grupo })
}

const { getCategoriaArquivos } = categoriaArquivosService()
const loading = ref({ tabs: true })

async function fetchAllCategoriaArquivos(params = {}) {
  let nextPage = 1

  try {
    loading.value.tabs = true

    while (nextPage) {
      const r = await getCategoriaArquivos({
        ...params,
        page: nextPage,
      })

      tabs.value = [...tabs.value, ...r.results]
      nextPage = r.next
        ? new URL(r.next).searchParams.get('page')
        : null
    }
  } catch (error) {
    useApiError(error)
  } finally {
    loading.value.tabs = false
    return tabs
  }
}

onMounted(async () => {
  const paramsStr = document.body.getAttribute('vue-params')
  if (!paramsStr) return

  const params = new URLSearchParams(paramsStr)
  const parsedParams =
    params === '?' ? {} : Object.fromEntries(params.entries())
  const _tabs = await fetchAllCategoriaArquivos(parsedParams)

  tabs.value = _tabs.value.map(({ nome, id, tipo_template, informar_grupo, exibir_select_ano }) => ({
    name: id,
    label: nome,
    tipo_template,
    informar_grupo,
    exibir_select_ano,
  }))

  tab.value = tabs.value.at().name
})

const colsSolicitacoesArquivos = computed(() => [
  {
    name: 'status',
    field: 'status',
    label: t('cols.solicitacoes.status'),
    align: 'left',
    sortable: true,
  },

  // {
  //   name: 'tamanho',
  //   field: 'tamanho',
  //   label: 'Tamanho',
  //   align: 'left',
  //   sortable: true,
  // },

  {
    name: 'fabricante__nome',
    field: (row) => row.fabricante.nome,
    label: t('cols.solicitacoes.manufacturer'),
    align: 'left',
    sortable: true,
  },

  {
    name: 'fabricante__zona__nome',
    field: (row) => row.fabricante.nome,
    label: t('cols.solicitacoes.region'),
    align: 'left',
    sortable: true,
  },
  {
    name: 'grupo_arquivo__nome',
    field: 'grupo_arquivo',
    label: t('cols.solicitacoes.group'),
    align: 'left',
    sortable: true,
  },

  {
    name: 'data_abertura',
    field: 'data_abertura',
    label: t('cols.solicitacoes.openDate'),
    align: 'left',
    sortable: true,
  },

  {
    name: 'data_fechamento',
    field: 'data_fechamento',
    label: t('cols.solicitacoes.closeDate'),
    align: 'left',
    sortable: true,
  },

  {
    name: 'template',
    field: 'template',
    label: t('cols.solicitacoes.template'),
    align: 'left',
  },

  {
    name: 'user',
    field: 'user',
    label: t('cols.solicitacoes.user'),
    align: 'left',
  },

  {
    name: 'observacoes',
    field: 'observacoes',
    label: t('cols.solicitacoes.comments'),
    align: 'left',
    sortable: true,
  },

  {
    name: 'anexar',
    label: t('cols.solicitacoes.attach'),
    align: 'left',
    style: 'width:100px',
  },
])
</script>

<style lang="scss" scoped>
.TableSolicitacoes {
  :deep(thead tr th:last-child) {
    width: 0px;
  }
}
</style>
